import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.7197 1.82227L22.4385 11.1748L10.9746 22.6387L1.0752 12.7393L12.6865 1.12793L21.7197 1.82227ZM17.3887 6.25488C16.4123 5.2785 14.8299 5.2785 13.8535 6.25488C12.8772 7.23127 12.8772 8.81368 13.8535 9.79004C14.8299 10.7664 16.4123 10.7664 17.3887 9.79004C18.3651 8.81366 18.365 7.23127 17.3887 6.25488Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 16V18H19V16H23Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 20V22H15V20H23Z"}}]};

const DiscountListFilled = Vue.extend<IconProps>({
  name: 'DiscountListFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'discount-list-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DiscountListFilled;
